import { CircularProgress, Stack } from '@mui/material';
import { useEffect, useState } from "react";
import ReactInputMask from 'react-input-mask';
import Typewriter from 'typewriter-effect';
import Header from "../components/header";
import { AddressModel, SignupModelHelper } from "../data/SignupModel";
import { useDebouncedValue } from '../hooks/use-debounce';
import AmarelinhoService from '../services/AmarelinhoService';
import { AmplitudeService } from '../services/AmplitudeService';

const REQUIRED_FIELD = "Campo obrigatório";

const INITIAL_ERRORS = {
  zipCode: '',
  street: '',
  number: '',
  neighborhood: '',
  state: '',
  city: '',
};

export default function EnderecoLogradouro(props: any) {

  const [typed, setTyped] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [values, setValues] = useState({
    zipCode: '',
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    state: '',
    city: '',
  });

  const [errors, setErrors] = useState<Partial<typeof INITIAL_ERRORS>>(INITIAL_ERRORS)

  const debouncedZipCode = useDebouncedValue(values.zipCode, 500);



  async function validateZipCode(zipCode: string): Promise<boolean> {
    zipCode = zipCode.replace(/[^0-9]/gm, '');
    if (zipCode.length === 8) {
      const result = await AmarelinhoService.getAddressByZipCode(zipCode);
      if (!result.success) {
        setErrors(previous => ({ ...previous, zipCode: 'CEP não encontrado' }));
      } else {
        setErrors(previous => ({ ...previous, zipCode: '' }));
        setValues((previous) => ({
          ...previous,
          state: result.uf,
          city: result.localidade,
          neighborhood: result.bairro,
          street: result.logradouro
        }));
        return true;
      }
    }
    return false;
  }


  useEffect(() => {
    validateZipCode(debouncedZipCode);
  }, [debouncedZipCode])

  useEffect(() => {
    // TagManager.dataLayer(dataLayerHelper.pagina('endereco', 'cadastro-usuario'));
    AmplitudeService.track('Address Screen')

    const signup = SignupModelHelper.get();
    if (signup) {
      if (signup.address) {
        setValues(signup.address);
      }
    } else {
      document.location = './';
    }
  }, [])


  function validate(address: AddressModel): boolean {
    const newErrors: Partial<typeof errors> = { ...errors };
    let hasError = false;
    if (!address.zipCode) {
      newErrors.zipCode = REQUIRED_FIELD;
      hasError = true;
    } else if (address.zipCode.replace(/[^0-9]/gm, '').length !== 8) {
      newErrors.zipCode = "O CEP deve ter 8 caracteres";
      hasError = true;
    } else {
      newErrors.zipCode = ''
    }
    if (!address.street) {
      newErrors.street = REQUIRED_FIELD;
      hasError = true;
    } else {
      newErrors.street = ''
    }
    if (!address.number) {
      newErrors.number = REQUIRED_FIELD;
      hasError = true;
    } else {
      newErrors.number = ''
    }
    if (!address.neighborhood) {
      newErrors.neighborhood = REQUIRED_FIELD;
      hasError = true;
    } else {
      newErrors.neighborhood = ''
    }
    if (!address.city) {
      newErrors.city = REQUIRED_FIELD;
      hasError = true;
    } else {
      newErrors.city = ''
    }
    if (!address.state) {
      newErrors.state = REQUIRED_FIELD;
      hasError = true;
    } else {
      newErrors.state = ''
    }

    setErrors(newErrors);

    return !hasError;
  }


  function handleChange(e: React.FormEvent<HTMLInputElement>) {
    const { value, name } = e.currentTarget;
    const newValues = { ...values, [name]: value };
    setValues(newValues);
    validate(newValues);
  }

  async function handleChangeZipCode(e: React.FormEvent<HTMLInputElement>) {
    const { value } = e.currentTarget;
    const newValues = { ...values, zipCode: value };
    setValues(newValues);
    validate(newValues);
  }

  async function submitAddress() {
    setSubmitted(true);
    setLoading(true);
    if (validate(values) && await validateZipCode(values.zipCode)) {
      SignupModelHelper.update({ address: { ...values } });
      AmplitudeService.track('Address Submit', { city: values.city, state: values.state })
      document.location = '#/celular';
    }
    setLoading(false);
  }

  return (
    <>
      <Header step={ 6 } total={ 11 } title="Seu endereço" previous="#/nascimento"></Header>
      <div className="chat-container">
        <div className="chat">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">
                <div className="chat-item" style={ { marginBottom: 6 } }>
                  <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                  <div className="chat-item-content">
                    <Typewriter
                      onInit={ (typewriter) => {
                        typewriter.changeDelay(15).typeString('Pronto!\nAgora, preciso do seu endereço.')
                          .callFunction(() => setTyped(true))
                          .start()
                      } } />
                  </div>
                </div>

                { typed && (
                  <>
                    <form className='form-vertical' onSubmit={ submitAddress }>
                      <div className={ `field ${!!errors['zipCode'] ? 'error' : ''}` }>
                        <label>
                          <span>CEP* <a href="https://buscacepinter.correios.com.br/app/endereco/index.php" target="_blank" rel="noreferrer">Não sei o CEP</a></span>
                          <ReactInputMask mask="99.999-999" type="text" name="zipCode" onChange={ handleChangeZipCode } value={ values.zipCode } />
                          { !!errors['zipCode'] && (<span className="error-message">{ errors['zipCode'] }</span>) }
                        </label>
                      </div>
                      <div className={ `field ${submitted && !!errors['street'] ? 'error' : ''}` }>
                        <label>
                          <span>Logradouro*</span>
                          <input type="text" name="street" onChange={ handleChange } value={ values.street } />
                          { submitted && !!errors['street'] && (<span className="error-message">{ errors['street'] }</span>) }
                        </label>
                      </div>
                      <div className={ `field ${submitted && !!errors['number'] ? 'error' : ''}` }>
                        <label>
                          <span>Número*</span>
                          <input type="text" name="number" onChange={ handleChange } value={ values.number } />
                          { submitted && !!errors['number'] && (<span className="error-message">{ errors['number'] }</span>) }
                        </label>
                      </div>
                      <div className="field">
                        <label>
                          <span>Complemento</span>
                          <input type="text" name="complement" onChange={ handleChange } value={ values.complement } />
                        </label>
                      </div>
                      <div className={ `field ${submitted && !!errors['neighborhood'] ? 'error' : ''}` }>
                        <label>
                          <span>Bairro*</span>
                          <input type="text" name="neighborhood" onChange={ handleChange } value={ values.neighborhood } />
                          { submitted && !!errors['neighborhood'] && (<span className="error-message">{ errors['neighborhood'] }</span>) }
                        </label>
                      </div>
                      <div className="d-flex">
                        <div className={ `field ${submitted && !!errors['city'] ? 'error' : ''}` }>
                          <label>
                            <span>Cidade*</span>
                            <input type="text" value={ values.city } readOnly disabled />
                            { submitted && !!errors['city'] && (<span className="error-message">{ errors['city'] }</span>) }
                          </label>
                        </div>
                        <div className={ `field ${submitted && !!errors['state'] ? 'error' : ''}` } style={ { maxWidth: 64 } }>
                          <label>
                            <span>Estado*</span>
                            <input type="text" value={ values.state } readOnly disabled />
                            { submitted && !!errors['state'] && (<span className="error-message">{ errors['state'] }</span>) }
                          </label>
                        </div>
                      </div>
                    </form >


                  </>
                ) }
              </div>
            </div>
          </div>
        </div>
        <footer className="footer-answer">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer-answer-holder d-flex align-items-center justify-content-end">
                  { loading &&
                    <Stack sx={ { color: '#6F5192' } } justifyContent="center" alignItems="center">
                      <CircularProgress color="inherit" />
                    </Stack>
                  }
                  { !loading && <button type="button" className="btn-submit" onClick={ submitAddress }>
                    <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0114286 20L24 10L0.0114286 0L0 7.77778L17.1429 10L0 12.2222L0.0114286 20Z"></path></svg>
                  </button> }
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>);
}




